import styled, {
  breakpoints,
  css,
  Device,
  IFalconTheme,
  Image,
  ResponsiveTypography,
  Scale,
  StyledComponent,
} from '@se-admin/falcon';

interface IBookingDetailsPageWrapperProps {
  imageColumnWidth: number;
}

const LOGO_WIDTH: number = 110;
const DESKTOP_IMAGE_WIDTH: number = 330;

export const BookingDetailsPageWrapper: StyledComponent<
  'div',
  IFalconTheme,
  IBookingDetailsPageWrapperProps
> = styled('div')`
  @media only screen and (min-width: ${breakpoints[Device.tablet]}) {
    display: grid;
    grid-template-columns: ${DESKTOP_IMAGE_WIDTH}px auto 13%;
  }
`;

export const BookingOfferDetailsContainer: StyledComponent<'div', IFalconTheme> = styled('div')(
  ({ theme }: { theme: IFalconTheme }) => css`
    background-color: ${theme.color.white};
  `
);

export const TipContainer: StyledComponent<'div', IFalconTheme, {}> = styled('div')(
  ({ theme }: { theme: IFalconTheme }) => {
    return css`
      display: flex;
      flex-direction: column;
      background: ${theme.color.smart05};
      border-left: ${Scale.xxxs} solid ${theme.color.smart30};
      padding: ${Scale.xs};
      margin: ${Scale.l} 0;
    `;
  }
);

export const WarningContainer: StyledComponent<'div', IFalconTheme, {}> = styled('div')(
  ({ theme }: { theme: IFalconTheme }) => {
    return css`
      display: flex;
      flex-direction: column;
      background: ${theme.color.warning05};
      border-left: ${Scale.xxxs} solid ${theme.color.warning30};
      padding: ${Scale.xs};
      margin: ${Scale.l} 0;
    `;
  }
);

export const CancellationInformationContainer: StyledComponent<'div', IFalconTheme, {}> = styled(
  'div'
)`
  @media only screen and (min-width: ${breakpoints[Device.tablet]}) {
    width: ${DESKTOP_IMAGE_WIDTH}px;
    box-sizing: border-box;
  }
`;

export const BookingDetailsWrapper: StyledComponent<'div', IFalconTheme> = styled('div')`
  padding-right: ${Scale.m};
  padding-left: ${Scale.m};
  @media only screen and (min-width: ${breakpoints[Device.tablet]}) {
    padding: 0 ${Scale.l} 0;
  }
`;

export const BookingDetailsDatesContainer: StyledComponent<'div', IFalconTheme> = styled('div')`
  margin: ${Scale.xl} 0 0;
  @media only screen and (min-width: ${breakpoints[Device.tablet]}) {
    margin: ${Scale.m} 0;
  }
`;

export const BookingDetailsHeaderContainer: StyledComponent<'div', IFalconTheme> = styled('div')`
  display: grid;
`;

export const BookingDetailsHeaderWrapper: StyledComponent<'div', IFalconTheme> = styled('div')`
  grid-column: 1;
  grid-row: 1;
  display: flex;
  align-items: flex-end;
  margin: 0 ${Scale.m} ${Scale.xs};
  z-index: 1;
`;

export const BookingDetailsGridWrapper: StyledComponent<'div', IFalconTheme> = styled('div')`
  grid-column: 1;
  grid-row: 1;
`;

export const BookingDetailsDatesWrapper: StyledComponent<'div', IFalconTheme> = styled('div')`
  display: flex;
  gap: ${Scale.m};
  justify-content: space-between;
  align-items: center;
`;

export const OriginalOfferDetailsContainer: StyledComponent<'div', IFalconTheme> = styled('div')(
  ({ theme }: { theme: IFalconTheme }) => {
    return css`
      padding: ${Scale.l};
      background: ${theme.color.grey05};
    `;
  }
);

export const AmendedOfferDetailsContainer: StyledComponent<'div', IFalconTheme> = styled('div')`
  padding: ${Scale.l};
`;

export const BookingDetailsHeaderOverlay: StyledComponent<'div', IFalconTheme> = styled('div')(
  ({ theme }: { theme: IFalconTheme }) => {
    return css`
      grid-column: 1;
      grid-row: 1;
      background: linear-gradient(180deg, transparent 30%, ${theme.color.black} 100%);
      opacity: 0.8;
    `;
  }
);

export const BookingDetailsHotelWrapper: StyledComponent<'div', IFalconTheme> = styled('div')`
  padding-top: ${Scale.m};
  padding-bottom: ${Scale.xl};
`;

export const BookingDetailsHotelDetailslWrapper: StyledComponent<'div', IFalconTheme> = styled(
  'div'
)`
  display: grid;
  grid-template-columns: minmax(min-content, max-content) auto;
  column-gap: ${Scale.xxs};
`;

export const BookingDatesItemWrapper: StyledComponent<'div', IFalconTheme> = styled('div')`
  margin-right: ${Scale.m};
`;

export const RefundInformationContainer: StyledComponent<'div', IFalconTheme> = styled('div')`
  margin: ${Scale.m} 0;
`;

export const HorizontalSeperator: StyledComponent<'hr', IFalconTheme, {}> = styled('hr')(
  ({ theme }: { theme: IFalconTheme }) => {
    return css`
      margin: ${Scale.m} 0;
      border-top: 1px solid ${theme.color.grey30};
    `;
  }
);

export const BookingDetailsTransactionWrapper: StyledComponent<'div', IFalconTheme> = styled('div')`
  display: grid;
  grid-template-columns: minmax(min-content, max-content) auto;
  column-gap: ${Scale.xs};
`;

export const CustomNormalImage: StyledComponent<typeof Image, {}, {}> = styled(Image)`
  top: 0;
  left: 0;
`;

export const CustomLogoImage: StyledComponent<typeof Image, {}, {}> = styled(Image)`
  width: ${LOGO_WIDTH}px;
`;

export const IconLabelContainer: StyledComponent<'div', {}, {}> = styled('div')`
  margin-bottom: ${Scale.xs};
`;

export const StyledResponsiveTypography: StyledComponent<
  typeof ResponsiveTypography,
  {},
  {}
> = styled(ResponsiveTypography)`
  margin-bottom: ${Scale.xs};
`;

export const BookingNotCancellableWrapper: StyledComponent<'div', IFalconTheme> = styled('div')`
  margin: ${Scale.xxs};
`;
